import { PapiClientConsumer } from "./PapiClient";
import { SwanPublicClient } from "swan-public-api-client";
import React from "react";

export interface PapiClientProps {
  papiClient: SwanPublicClient;
}

export function withPapi<T extends PapiClientProps>(
  WrappedComponent: React.ComponentType<T>
) {
  type TWithoutPapi = Pick<T, Exclude<keyof T, keyof PapiClientProps>>;

  return (props: TWithoutPapi) => {
    return (
      <PapiClientConsumer>
        {state => {
          const outProps = { ...props, papiClient: state.client } as T;
          return <WrappedComponent {...outProps} />;
        }}
      </PapiClientConsumer>
    );
  };
}
